export interface SizeTemplate {
  name: string;
  category?: string;
  sizes: string[];
  measurements?: Record<string, Record<string, string>>;
}

export const sizeTemplates: Record<string, SizeTemplate[]> = {
  "Üst Giyim": [
    {
      name: "Standart Üst Giyim",
      sizes: ["XS", "S", "M", "L", "XL", "XXL"],
      measurements: {
        "Göğüs": { XS: "86", S: "91", M: "96", L: "101", XL: "106", XXL: "111" },
        "Bel": { XS: "71", S: "76", M: "81", L: "86", XL: "91", XXL: "96" },
        "Kalça": { XS: "91", S: "96", M: "101", L: "106", XL: "111", XXL: "116" },
        "Boy": { XS: "62", S: "64", M: "66", L: "68", XL: "70", XXL: "72" },
        "Kol Boyu": { XS: "58", S: "59", M: "60", L: "61", XL: "62", XXL: "63" },
        "Omuz": { XS: "38", S: "39", M: "40", L: "41", XL: "42", XXL: "43" },
        "Yaka": { XS: "36", S: "37", M: "38", L: "39", XL: "40", XXL: "41" }
      }
    },
    {
      name: "Slim Fit Üst Giyim",
      sizes: ["XS", "S", "M", "L", "XL", "XXL"],
      measurements: {
        "Göğüs": { XS: "84", S: "89", M: "94", L: "99", XL: "104", XXL: "109" },
        "Bel": { XS: "69", S: "74", M: "79", L: "84", XL: "89", XXL: "94" },
        "Kalça": { XS: "89", S: "94", M: "99", L: "104", XL: "109", XXL: "114" },
        "Boy": { XS: "62", S: "64", M: "66", L: "68", XL: "70", XXL: "72" },
        "Kol Boyu": { XS: "58", S: "59", M: "60", L: "61", XL: "62", XXL: "63" },
        "Omuz": { XS: "37", S: "38", M: "39", L: "40", XL: "41", XXL: "42" },
        "Yaka": { XS: "35", S: "36", M: "37", L: "38", XL: "39", XXL: "40" }
      }
    },
    { name: "Basic T-Shirt", category: "Üst Giyim", sizes: ["XS", "S", "M", "L", "XL", "2XL"], measurements: {
      "Göğüs": { XS: "88", S: "94", M: "100", L: "106", XL: "112", "2XL": "118" },
      "Bel": { XS: "76", S: "82", M: "88", L: "94", XL: "100", "2XL": "106" },
      "Boy": { XS: "67", S: "69", M: "71", L: "73", XL: "75", "2XL": "77" },
      "Kol Boyu": { XS: "19", S: "20", M: "21", L: "22", XL: "23", "2XL": "24" }
    } },
    { name: "Unisex T-Shirt", category: "Üst Giyim", sizes: ["2XS", "XS", "S", "M", "L", "XL", "2XL", "3XL"], measurements: {
      "Göğüs": { "2XS": "84", XS: "88", S: "94", M: "100", L: "106", XL: "112", "2XL": "118", "3XL": "124" },
      "Bel": { "2XS": "72", XS: "76", S: "82", M: "88", L: "94", XL: "100", "2XL": "106", "3XL": "112" },
      "Boy": { "2XS": "65", XS: "67", S: "69", M: "71", L: "73", XL: "75", "2XL": "77", "3XL": "79" },
      "Kol Boyu": { "2XS": "18", XS: "19", S: "20", M: "21", L: "22", XL: "23", "2XL": "24", "3XL": "25" }
    } },
    { name: "Fitted T-Shirt", category: "Üst Giyim", sizes: ["XS", "S", "M", "L", "XL"], measurements: {
      "Göğüs": { XS: "84", S: "88", M: "92", L: "96", XL: "100" },
      "Bel": { XS: "70", S: "74", M: "78", L: "82", XL: "86" },
      "Boy": { XS: "65", S: "67", M: "69", L: "71", XL: "73" },
      "Kol Boyu": { XS: "18", S: "19", M: "20", L: "21", XL: "22" }
    } },
    { name: "Oversize T-Shirt", category: "Üst Giyim", sizes: ["XS", "S", "M", "L", "XL", "2XL"], measurements: {
      "Göğüs": { XS: "100", S: "106", M: "112", L: "118", XL: "124", "2XL": "130" },
      "Bel": { XS: "88", S: "94", M: "100", L: "106", XL: "112", "2XL": "118" },
      "Boy": { XS: "70", S: "72", M: "74", L: "76", XL: "78", "2XL": "80" },
      "Kol Boyu": { XS: "22", S: "23", M: "24", L: "25", XL: "26", "2XL": "27" }
    } },
    { name: "Erkek Gömlek", category: "Üst Giyim", sizes: ["36", "38", "40", "42", "44", "46"], measurements: {
      "Göğüs": { "36": "92", "38": "96", "40": "100", "42": "104", "44": "108", "46": "112" },
      "Bel": { "36": "80", "38": "84", "40": "88", "42": "92", "44": "96", "46": "100" },
      "Boy": { "36": "72", "38": "74", "40": "76", "42": "78", "44": "80", "46": "82" },
      "Kol Boyu": { "36": "60", "38": "61", "40": "62", "42": "63", "44": "64", "46": "65" }
    } },
    { name: "Kadın Gömlek", category: "Üst Giyim", sizes: ["34", "36", "38", "40", "42", "44"], measurements: {
      "Göğüs": { "34": "84", "36": "88", "38": "92", "40": "96", "42": "100", "44": "104" },
      "Bel": { "34": "68", "36": "72", "38": "76", "40": "80", "42": "84", "44": "88" },
      "Boy": { "34": "68", "36": "70", "38": "72", "40": "74", "42": "76", "44": "78" },
      "Kol Boyu": { "34": "58", "36": "59", "38": "60", "40": "61", "42": "62", "44": "63" }
    } },
    { name: "Sweatshirt", category: "Üst Giyim", sizes: ["XS", "S", "M", "L", "XL", "2XL"], measurements: {
      "Göğüs": { XS: "100", S: "104", M: "108", L: "112", XL: "116", "2XL": "120" },
      "Bel": { XS: "92", S: "96", M: "100", L: "104", XL: "108", "2XL": "112" },
      "Boy": { XS: "69", S: "71", M: "73", L: "75", XL: "77", "2XL": "79" },
      "Kol Boyu": { XS: "63", S: "64", M: "65", L: "66", XL: "67", "2XL": "68" }
    } },
    { name: "Ceket", category: "Üst Giyim", sizes: ["44", "46", "48", "50", "52", "54", "56"], measurements: {
      "Göğüs": { "44": "104", "46": "108", "48": "112", "50": "116", "52": "120", "54": "124", "56": "128" },
      "Bel": { "44": "92", "46": "96", "48": "100", "50": "104", "52": "108", "54": "112", "56": "116" },
      "Omuz": { "44": "44", "46": "45", "48": "46", "50": "47", "52": "48", "54": "49", "56": "50" },
      "Boy": { "44": "70", "46": "71", "48": "72", "50": "73", "52": "74", "54": "75", "56": "76" },
      "Kol Boyu": { "44": "62", "46": "63", "48": "64", "50": "65", "52": "66", "54": "67", "56": "68" }
    } }
  ],
  "Alt Giyim": [
    {
      name: "Standart Pantolon",
      sizes: ["28", "30", "32", "34", "36", "38"],
      measurements: {
        "Bel": { "28": "71", "30": "76", "32": "81", "34": "86", "36": "91", "38": "96" },
        "Kalça": { "28": "91", "30": "96", "32": "101", "34": "106", "36": "111", "38": "116" },
        "İç Bacak": { "28": "76", "30": "76", "32": "76", "34": "76", "36": "76", "38": "76" },
        "Dış Bacak": { "28": "102", "30": "102", "32": "102", "34": "102", "36": "102", "38": "102" },
        "Bacak Genişliği": { "28": "20", "30": "21", "32": "22", "34": "23", "36": "24", "38": "25" },
        "Paça Genişliği": { "28": "18", "30": "19", "32": "20", "34": "21", "36": "22", "38": "23" }
      }
    },
    {
      name: "Slim Fit Pantolon",
      sizes: ["28", "30", "32", "34", "36", "38"],
      measurements: {
        "Bel": { "28": "69", "30": "74", "32": "79", "34": "84", "36": "89", "38": "94" },
        "Kalça": { "28": "89", "30": "94", "32": "99", "34": "104", "36": "109", "38": "114" },
        "İç Bacak": { "28": "76", "30": "76", "32": "76", "34": "76", "36": "76", "38": "76" },
        "Dış Bacak": { "28": "102", "30": "102", "32": "102", "34": "102", "36": "102", "38": "102" },
        "Bacak Genişliği": { "28": "18", "30": "19", "32": "20", "34": "21", "36": "22", "38": "23" },
        "Paça Genişliği": { "28": "16", "30": "17", "32": "18", "34": "19", "36": "20", "38": "21" }
      }
    },
    { name: "Erkek Jean İnç", category: "bottoms", sizes: ["28/30", "29/30", "30/30", "31/30", "32/30", "33/30", "34/30", "36/30", "38/30"] },
    { name: "Kadın Jean İnç", category: "bottoms", sizes: ["24/30", "25/30", "26/30", "27/30", "28/30", "29/30", "30/30", "31/30", "32/30"] },
    { name: "Erkek Şort", category: "bottoms", sizes: ["S", "M", "L", "XL", "2XL"] },
    { name: "Kadın Şort", category: "bottoms", sizes: ["XS", "S", "M", "L", "XL"] },
    { name: "Spor Tayt", category: "bottoms", sizes: ["XS", "S", "M", "L", "XL"] }
  ],
  "Dış Giyim": [
    { name: "Erkek Mont", category: "outerwear", sizes: ["46", "48", "50", "52", "54", "56", "58"] },
    { name: "Kadın Mont", category: "outerwear", sizes: ["36", "38", "40", "42", "44", "46"] },
    {
      name: "Unisex Yağmurluk",
      sizes: ["XS", "S", "M", "L", "XL", "2XL"],
      measurements: {
        "Göğüs": { XS: "96", S: "101", M: "106", L: "111", XL: "116", "2XL": "121" },
        "Bel": { XS: "81", S: "86", M: "91", L: "96", XL: "101", "2XL": "106" },
        "Kalça": { XS: "101", S: "106", M: "111", L: "116", XL: "121", "2XL": "126" },
        "Boy": { XS: "64", S: "66", M: "68", L: "70", XL: "72", "2XL": "74" },
        "Kol Boyu": { XS: "60", S: "61", M: "62", L: "63", XL: "64", "2XL": "65" },
        "Omuz": { XS: "40", S: "41", M: "42", L: "43", XL: "44", "2XL": "45" },
        "Yaka": { XS: "38", S: "39", M: "40", L: "41", XL: "42", "2XL": "43" },
        "Kapüşon": { XS: "58", S: "59", M: "60", L: "61", XL: "62", "2XL": "63" }
      }
    },
    { name: "Parka", category: "outerwear", sizes: ["XS", "S", "M", "L", "XL", "2XL"] },
    { name: "Blazer", category: "outerwear", sizes: ["34", "36", "38", "40", "42", "44", "46"] }
  ],
  "Çocuk": [
    {
      name: "Çocuk Üst Giyim",
      sizes: ["2T", "3T", "4T", "5T", "6T"],
      measurements: {
        "Göğüs": { "2T": "56", "3T": "58", "4T": "60", "5T": "62", "6T": "64" },
        "Bel": { "2T": "53", "3T": "54", "4T": "55", "5T": "56", "6T": "57" },
        "Kalça": { "2T": "58", "3T": "60", "4T": "62", "5T": "64", "6T": "66" },
        "Boy": { "2T": "86", "3T": "92", "4T": "98", "5T": "104", "6T": "110" },
        "Kol Boyu": { "2T": "32", "3T": "34", "4T": "36", "5T": "38", "6T": "40" }
      }
    },
    {
      name: "Çocuk Pantolon",
      sizes: ["2T", "3T", "4T", "5T", "6T"],
      measurements: {
        "Bel": { "2T": "53", "3T": "54", "4T": "55", "5T": "56", "6T": "57" },
        "Kalça": { "2T": "58", "3T": "60", "4T": "62", "5T": "64", "6T": "66" },
        "İç Bacak": { "2T": "32", "3T": "34", "4T": "36", "5T": "38", "6T": "40" },
        "Dış Bacak": { "2T": "45", "3T": "48", "4T": "51", "5T": "54", "6T": "57" }
      }
    },
    { name: "Bebek (Ay)", category: "kids", sizes: ["0-3", "3-6", "6-9", "9-12", "12-18", "18-24"], measurements: {
      "Boy": { "0-3": "56", "3-6": "62", "6-9": "68", "9-12": "74", "12-18": "80", "18-24": "86" },
      "Göğüs": { "0-3": "41", "3-6": "43", "6-9": "45", "9-12": "47", "12-18": "49", "18-24": "51" },
      "Bel": { "0-3": "40", "3-6": "41", "6-9": "42", "9-12": "43", "12-18": "44", "18-24": "45" }
    } },
    { name: "Toddler (Yaş)", category: "kids", sizes: ["2T", "3T", "4T", "5T"], measurements: {
      "Boy": { "2T": "92", "3T": "98", "4T": "104", "5T": "110" },
      "Göğüs": { "2T": "54", "3T": "56", "4T": "58", "5T": "60" },
      "Bel": { "2T": "50", "3T": "52", "4T": "54", "5T": "56" }
    } },
    { name: "Çocuk (Yaş)", category: "kids", sizes: ["4", "5", "6", "7", "8", "9", "10", "11", "12"], measurements: {
      "Boy": { "4": "104", "5": "110", "6": "116", "7": "122", "8": "128", "9": "134", "10": "140", "11": "146", "12": "152" },
      "Göğüs": { "4": "58", "5": "60", "6": "62", "7": "64", "8": "66", "9": "68", "10": "70", "11": "72", "12": "74" },
      "Bel": { "4": "54", "5": "55", "6": "56", "7": "57", "8": "58", "9": "59", "10": "60", "11": "61", "12": "62" }
    } },
    { name: "Genç (Yaş)", category: "kids", sizes: ["8", "10", "12", "14", "16"], measurements: {
      "Boy": { "8": "128", "10": "140", "12": "152", "14": "164", "16": "176" },
      "Göğüs": { "8": "66", "10": "70", "12": "74", "14": "78", "16": "82" },
      "Bel": { "8": "58", "10": "60", "12": "62", "14": "64", "16": "66" }
    } },
    { name: "Çocuk EU", category: "kids", sizes: ["104", "110", "116", "122", "128", "134", "140", "146", "152", "158", "164"], measurements: {
      "Boy": { "104": "104", "110": "110", "116": "116", "122": "122", "128": "128", "134": "134", "140": "140", "146": "146", "152": "152", "158": "158", "164": "164" },
      "Göğüs": { "104": "56", "110": "58", "116": "60", "122": "62", "128": "64", "134": "66", "140": "68", "146": "70", "152": "72", "158": "74", "164": "76" }
    } }
  ],
  "Ayakkabı": [
    { name: "Erkek EU", category: "shoes", sizes: ["39", "40", "41", "42", "43", "44", "45", "46"], measurements: {
      "Ayak Uzunluğu (cm)": {
        "39": "25", "40": "25.5", "41": "26", "42": "26.5", "43": "27.5", "44": "28", "45": "28.5", "46": "29"
      }
    } },
    { name: "Kadın EU", category: "shoes", sizes: ["35", "36", "37", "38", "39", "40", "41"], measurements: {
      "Ayak Uzunluğu (cm)": {
        "35": "22.5", "36": "23", "37": "23.5", "38": "24", "39": "24.5", "40": "25", "41": "25.5"
      }
    } },
    { name: "Çocuk EU", category: "shoes", sizes: ["28", "29", "30", "31", "32", "33", "34", "35"], measurements: {
      "Ayak Uzunluğu (cm)": {
        "28": "17.5", "29": "18", "30": "18.5", "31": "19", "32": "19.5", "33": "20", "34": "20.5", "35": "21"
      }
    } },
    { name: "UK Unisex", category: "shoes", sizes: ["3", "4", "5", "6", "7", "8", "9", "10", "11", "12"], measurements: {
      "Ayak Uzunluğu (cm)": {
        "3": "22.5", "4": "23", "5": "23.5", "6": "24", "7": "24.5", "8": "25", "9": "25.5", "10": "26", "11": "26.5", "12": "27"
      }
    } },
    { name: "US Erkek", category: "shoes", sizes: ["6", "7", "8", "9", "10", "11", "12", "13"], measurements: {
      "Ayak Uzunluğu (cm)": {
        "6": "24.5", "7": "25", "8": "25.5", "9": "26", "10": "26.5", "11": "27", "12": "27.5", "13": "28"
      }
    } },
    { name: "US Kadın", category: "shoes", sizes: ["5", "6", "7", "8", "9", "10", "11"], measurements: {
      "Ayak Uzunluğu (cm)": {
        "5": "22", "6": "22.5", "7": "23", "8": "23.5", "9": "24", "10": "24.5", "11": "25"
      }
    } }
  ],
  "İç Giyim": [
    { name: "Erkek İç Giyim", category: "underwear", sizes: ["S", "M", "L", "XL", "2XL"], measurements: {
      "Bel": { S: "76", M: "84", L: "92", XL: "100", "2XL": "108" }
    } },
    { name: "Kadın İç Giyim", category: "underwear", sizes: ["XS", "S", "M", "L", "XL"], measurements: {
      "Bel": { XS: "62", S: "66", M: "70", L: "74", XL: "78" }
    } },
    { name: "Sütyen", category: "underwear", sizes: ["70B", "75B", "80B", "85B", "90B", "75C", "80C", "85C", "90C", "75D", "80D", "85D"], measurements: {
      "Alt Göğüs": { "70B": "68-72", "75B": "73-77", "80B": "78-82", "85B": "83-87", "90B": "88-92", "75C": "73-77", "80C": "78-82", "85C": "83-87", "90C": "88-92", "75D": "73-77", "80D": "78-82", "85D": "83-87" }
    } },
    { name: "Çorap", category: "underwear", sizes: ["35-38", "39-42", "43-46"], measurements: {
      "Ayak Uzunluğu (cm)": { "35-38": "22-24", "39-42": "24-27", "43-46": "27-30" }
    } }
  ],
  "Spor Giyim": [
    { name: "Spor T-Shirt", category: "sportswear", sizes: ["XS", "S", "M", "L", "XL", "2XL"], measurements: {
      "Göğüs": { XS: "88", S: "94", M: "100", L: "106", XL: "112", "2XL": "118" }
    } },
    { name: "Spor Şort", category: "sportswear", sizes: ["XS", "S", "M", "L", "XL", "2XL"], measurements: {
      "Bel": { XS: "68", S: "72", M: "76", L: "80", XL: "84", "2XL": "88" }
    } },
    { name: "Forma", category: "sportswear", sizes: ["YXS", "YS", "YM", "YL", "S", "M", "L", "XL", "2XL"], measurements: {
      "Göğüs": { YXS: "70", YS: "76", YM: "82", YL: "88", S: "94", M: "100", L: "106", XL: "112", "2XL": "118" }
    } },
    { name: "Antrenman", category: "sportswear", sizes: ["XS", "S", "M", "L", "XL"], measurements: {
      "Göğüs": { XS: "88", S: "94", M: "100", L: "106", XL: "112" }
    } },
    { name: "Tayt", category: "sportswear", sizes: ["XS", "S", "M", "L", "XL"], measurements: {
      "Bel": { XS: "62", S: "66", M: "70", L: "74", XL: "78" }
    } }
  ],
  "Aksesuar": [
    { name: "Şapka", category: "accessories", sizes: ["S", "M", "L", "XL"], measurements: {
      "Baş Çevresi (cm)": { S: "54", M: "56", L: "58", XL: "60" }
    } },
    { name: "Eldiven", category: "accessories", sizes: ["XS", "S", "M", "L", "XL"], measurements: {
      "El Uzunluğu (cm)": { XS: "16", S: "17", M: "18", L: "19", XL: "20" }
    } },
    { name: "Kemer (cm)", category: "accessories", sizes: ["80", "85", "90", "95", "100", "105", "110"], measurements: {
      "Kemer Uzunluğu (cm)": { "80": "80", "85": "85", "90": "90", "95": "95", "100": "100", "105": "105", "110": "110" }
    } },
    { name: "Boyunluk", category: "accessories", sizes: ["S/M", "L/XL"], measurements: {
      "Çevre (cm)": { "S/M": "50", "L/XL": "55" }
    } },
    { name: "Bandana", category: "accessories", sizes: ["ONE SIZE"], measurements: {
      "Çevre (cm)": { "ONE SIZE": "55" }
    } }
  ],
  "Özel Ölçü": [
    { name: "Gelinlik", category: "custom", sizes: ["34", "36", "38", "40", "42", "44", "46"], measurements: {
      "Göğüs": { "34": "84", "36": "88", "38": "92", "40": "96", "42": "100", "44": "104", "46": "108" },
      "Bel": { "34": "66", "36": "70", "38": "74", "40": "78", "42": "82", "44": "86", "46": "90" },
      "Kalça": { "34": "92", "36": "96", "38": "100", "40": "104", "42": "108", "44": "112", "46": "116" }
    } },
    { name: "Smokin", category: "custom", sizes: ["46", "48", "50", "52", "54", "56", "58"], measurements: {
      "Göğüs": { "46": "92", "48": "96", "50": "100", "52": "104", "54": "108", "56": "112", "58": "116" },
      "Bel": { "46": "80", "48": "84", "50": "88", "52": "92", "54": "96", "56": "100", "58": "104" }
    } },
    { name: "Takım Elbise", category: "custom", sizes: ["44", "46", "48", "50", "52", "54", "56", "58"], measurements: {
      "Göğüs": { "44": "88", "46": "92", "48": "96", "50": "100", "52": "104", "54": "108", "56": "112", "58": "116" },
      "Bel": { "44": "76", "46": "80", "48": "84", "50": "88", "52": "92", "54": "96", "56": "100", "58": "104" }
    } },
    { name: "Üniforma", category: "custom", sizes: ["XS", "S", "M", "L", "XL", "2XL", "3XL"], measurements: {
      "Göğüs": { XS: "88", S: "94", M: "100", L: "106", XL: "112", "2XL": "118", "3XL": "124" },
      "Bel": { XS: "76", S: "82", M: "88", L: "94", XL: "100", "2XL": "106", "3XL": "112" }
    } }
  ],
  "Elbise": [
    {
      name: "Standart Elbise",
      sizes: ["XS", "S", "M", "L", "XL", "XXL"],
      measurements: {
        "Göğüs": { XS: "86", S: "91", M: "96", L: "101", XL: "106", XXL: "111" },
        "Bel": { XS: "71", S: "76", M: "81", L: "86", XL: "91", XXL: "96" },
        "Kalça": { XS: "91", S: "96", M: "101", L: "106", XL: "111", XXL: "116" },
        "Boy": { XS: "62", S: "64", M: "66", L: "68", XL: "70", XXL: "72" },
        "Kol Boyu": { XS: "58", S: "59", M: "60", L: "61", XL: "62", XXL: "63" },
        "Omuz": { XS: "38", S: "39", M: "40", L: "41", XL: "42", XXL: "43" },
        "Yaka": { XS: "36", S: "37", M: "38", L: "39", XL: "40", XXL: "41" },
        "Etek Boyu": { XS: "95", S: "95", M: "95", L: "95", XL: "95", XXL: "95" }
      }
    }
  ],
  "Bebek": [
    {
      name: "Bebek Tulum",
      sizes: ["0-3", "3-6", "6-9", "9-12", "12-18"],
      measurements: {
        "Göğüs": { "0-3": "41", "3-6": "43", "6-9": "45", "9-12": "47", "12-18": "49" },
        "Bel": { "0-3": "40", "3-6": "41", "6-9": "42", "9-12": "43", "12-18": "44" },
        "Kalça": { "0-3": "43", "3-6": "45", "6-9": "47", "9-12": "49", "12-18": "51" },
        "Boy": { "0-3": "56", "3-6": "62", "6-9": "68", "9-12": "74", "12-18": "80" },
        "Kol Boyu": { "0-3": "20", "3-6": "22", "6-9": "24", "9-12": "26", "12-18": "28" }
      }
    }
  ]
};
